<template>
  <div id="app" :class="appClasses" class="app">
    <menu-bar-container></menu-bar-container>
    <div class="content-wrapper">
      <router-view></router-view>
      <portal-target name="refer-a-friend-modal-destination"></portal-target>
    </div>
    <the-footer-container></the-footer-container>
  </div>
</template>

<script>

import TheFooterContainer from 'top20common/containers/TheFooterContainer';

import MenuBarContainer from '@/common/menu-bar/MenuBarContainer';

export default {
  created() {
    this.$store.dispatch('fetchFeatureSwitchesAction');
    this.$mam.setUTMTags();
  },
  beforeMount() {
    document.getElementById('headerBeforeInit').remove();
  },
  computed: {
    appClasses() {
      return `${this.$route.name}-page`;
    }
  },
  components: {MenuBarContainer, TheFooterContainer}
};
</script>

<style lang="scss">
@import '~CommonStyles/main.scss';
@import '~CommonStyles/extended/dropdown.scss';
@import '~CommonStyles/extended/button.scss';
@import '~CommonStyles/extended/tag.scss';
@import '~CommonStyles/extended/v-popover.scss';
@import '~CommonStyles/extended/tooltip.scss';
@import '~CommonStyles/extended/b-radio.scss';
@import '~CommonStyles/hopscotch.scss';
@import '~CommonStyles/typography.scss';

footer {
  background: var(--light-light-gray);
}

.job-page .mobile-footer {
  padding-bottom: 5px;
}

#app > .content-wrapper {
  min-height: calc(100% - 65px - 65px); // 100% - footer height - footer margin
}

@media screen and (min-width: $tablet) {
  #app {
    min-height: 100%;
    > .content-wrapper {
      min-height: calc(100% - 23px - 46px); // 100% - footer height - footer margin
    }
  }
}
</style>
